import { FileSpreadsheet, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const ProcurementSupplierLedgerSummary = ({
  totals,
  formatCurrency,
  ledgerExporting = false,
  onExport,
  canEdit = false,
  onAddSupplier,
  addSupplierLabel,
}) => (
  <>
    <div className="grid gap-3 md:grid-cols-5" data-testid="suppliers-ledger-summary-grid">
      <div className="rounded-2xl border border-slate-200 bg-white px-4 py-3">
        <p className="text-xs uppercase tracking-[0.18em] text-slate-500">Fornecedores</p>
        <p className="mt-1 text-lg font-semibold text-slate-900">{totals?.suppliers || 0}</p>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
        <p className="text-xs uppercase tracking-[0.18em] text-slate-500">Total encomendado</p>
        <p className="mt-1 text-lg font-semibold text-slate-900">{formatCurrency(totals?.total_ordered || 0)}</p>
      </div>
      <div className="rounded-2xl border border-blue-200 bg-blue-50 px-4 py-3">
        <p className="text-xs uppercase tracking-[0.18em] text-blue-700">Total recebido</p>
        <p className="mt-1 text-lg font-semibold text-blue-900">{formatCurrency(totals?.total_received || 0)}</p>
      </div>
      <div className="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3">
        <p className="text-xs uppercase tracking-[0.18em] text-emerald-700">Total pago</p>
        <p className="mt-1 text-lg font-semibold text-emerald-900">{formatCurrency(totals?.total_paid || 0)}</p>
      </div>
      <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3">
        <p className="text-xs uppercase tracking-[0.18em] text-amber-700">Saldo em aberto</p>
        <p className="mt-1 text-lg font-semibold text-amber-900">{formatCurrency(totals?.balance_due || 0)}</p>
      </div>
    </div>

    <div className="flex flex-wrap justify-end gap-2">
      <Button variant="outline" onClick={onExport} disabled={ledgerExporting} data-testid="suppliers-ledger-export-button">
        <FileSpreadsheet className="mr-2 h-4 w-4" />
        {ledgerExporting ? 'A exportar...' : 'Exportar conta corrente'}
      </Button>
      {canEdit && (
        <Button onClick={onAddSupplier} data-testid="add-supplier-button">
          <Plus className="mr-2 h-4 w-4" />
          {addSupplierLabel}
        </Button>
      )}
    </div>
  </>
);